export const getReportType = ( { reportModalReducer: { reportType } } ) => reportType;